function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7159 11.44H19.5185V4.16C19.5185 1.86225 17.6668 0 15.3821 0H7.3679C5.0832 0 3.23153 1.86225 3.23153 4.16V11.44H1.03409C0.462109 11.44 0 11.9047 0 12.48V24.96C0 25.5352 0.462109 26 1.03409 26H21.7159C22.2879 26 22.75 25.5352 22.75 24.96V12.48C22.75 11.9047 22.2879 11.44 21.7159 11.44ZM5.55824 4.16C5.55824 3.15575 6.36935 2.34 7.3679 2.34H15.3821C16.3806 2.34 17.1918 3.15575 17.1918 4.16V11.44H5.55824V4.16ZM20.4233 23.66H2.3267V13.78H20.4233V23.66Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4699 19.1418V20.8643C10.4699 21.0073 10.5862 21.1243 10.7284 21.1243H12.021C12.1632 21.1243 12.2795 21.0073 12.2795 20.8643V19.1418C12.5463 18.9492 12.7454 18.6764 12.8482 18.3627C12.951 18.0491 12.9522 17.7107 12.8516 17.3963C12.751 17.0819 12.5538 16.8078 12.2884 16.6133C12.023 16.4188 11.7031 16.314 11.3747 16.314C11.0463 16.314 10.7264 16.4188 10.461 16.6133C10.1956 16.8078 9.99842 17.0819 9.89783 17.3963C9.79723 17.7107 9.79842 18.0491 9.90122 18.3627C10.004 18.6764 10.2031 18.9492 10.4699 19.1418Z",
  fill: "currentColor"
});

var SvgIcStatusProductionOutlined = function SvgIcStatusProductionOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcStatusProductionOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_status_production_outlined.ba4efc06.svg";
export { ForwardRef as ReactComponent };